import React, { useMemo } from "react";
import RenderHtml, {
  defaultSystemFonts,
  MixedStyleDeclaration,
} from "react-native-render-html";
import { Dimensions, Platform, View, ViewProps } from "react-native";

const width = Dimensions.get("window").width;
interface RenderHtmlComponentProps extends ViewProps {
  source: string;
  textColor?: string;
  bodyStyle?: MixedStyleDeclaration;
}

const RenderHtmlComponent: React.FC<RenderHtmlComponentProps> = ({
  source,
  textColor = "black",
  bodyStyle,
  ...rest
}) => {
  const tagStyles = useMemo(
    () => ({
      body: {
        color: textColor,
        fontFamily: Platform.OS === "web" ? "Roboto-Regular" : undefined,
        letterSpacing: 1,
        lineHeight: 22,
        ...bodyStyle,
      },
    }),
    [textColor, bodyStyle]
  );

  return (
    <View {...rest}>
      <RenderHtml
        source={{
          html: source,
        }}
        contentWidth={width}
        tagsStyles={tagStyles}
        systemFonts={[...defaultSystemFonts, "Roboto-Regular", "sans-serif"]}
      />
    </View>
  );
};

export default React.memo(RenderHtmlComponent);
